import { createSlice } from "@reduxjs/toolkit";

const excelDataSlice = createSlice({
  name: "excelData",
  initialState: {
    drmExcelTableData: {
      onPage: 0,
      pageSize: 0,
      drmMaintenanceDetails: [],
      totalPages: 0,
      totalRecords: 0,
    },
    isLoading: false,
    errorMessage: undefined,
  },
  reducers: {
    getDrmExcelTableData: (state) => {
      state.isLoading = true;
      state.drmExcelTableData.drmMaintenanceDetails = [];
    },
    setDrmExcelTableDataSuccess: (state, action) => {
      state.isLoading = false;
      state.drmExcelTableData = action.payload;
    },
    setDrmExcelTableDataFailure: (state, action) => {
      state.isLoading = false;
      state.drmExcelTableData = {
        onPage: 0,
        pageSize: 0,
        drmMaintenanceDetails: [],
        totalPages: 0,
        totalRecords: 0,
      };
      state.errorMessage = action.payload;
    },
    resetExcelTableData: (state) => {
      state.isLoading = false;
      state.drmExcelTableData = {
        onPage: 0,
        pageSize: 0,
        drmMaintenanceDetails: [],
        totalPages: 0,
        totalRecords: 0,
      };
    },
  },
});

export const {
  getDrmExcelTableData,
  setDrmExcelTableDataSuccess,
  setDrmExcelTableDataFailure,
  resetExcelTableData,
} = excelDataSlice.actions;

export default excelDataSlice.reducer;
